import { Skeleton, Stack } from '@mantine/core';

/** Placeholder rows while a list/table loads (replaces the bare spinner). */
export function TableSkeleton({ rows = 8, height = 36 }: { rows?: number; height?: number }) {
  return (
    <Stack gap="xs" p="xs">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} height={height} radius="sm" />
      ))}
    </Stack>
  );
}
